export default __webpack_public_path__ + "static/Brown-Foundation-Lawn-Gathering1920px-04009944c5cd7ac2960026abb683fa47.jpg";